import React, { useState } from 'react'
import { setItem } from '../../../global/data/synch-storage.js'
import { getRelativeBasePath } from '../../../global/environments/path.js'
import {
  CHANGE_PASSWORD_SUCCESS,
  FORM_NAME_CHALLENGE_CHOICE,
  FORM_NAME_CHALLENGE_QUESTION,
  FORM_NAME_CHANGE_PASSWORD,
  FORM_NAME_LOGIN_FORM,
  FORM_NAME_ONE_TIME_PASSCODE,
  FORM_NAME_USER_ID,
  MFA_ANSWERED,
  PASSWORD_MODE,
} from '../../Login/Helpers/LoginHelper.js'
import ChallengeChoice from '../../Login/Modules/ChallengeChoice.jsx'
import ChallengeQuestion from '../../Login/Modules/ChallengeQuestion.jsx'
import ChangePassword from '../../Login/Modules/ChangePassword.jsx'
import OneTimePasscode from '../../Login/Modules/OneTimePasscode.jsx'
import { useUserIdHook } from './Hooks/UserIdHook.js'
import UserIdForm from './Modules/UserIdForm.jsx'

function ForgotPassword() {
  const userIdHook = useUserIdHook()
  const [displayForm, setDisplayForm] = useState(FORM_NAME_USER_ID)
  const [mfaData, setMfaData] = useState(null)
  const [otpDta, setOtpData] = useState(null)
  const [challengeQuestionData, setChallengeQuestionData] = useState(null)
  /* eslint no-unused-vars: 'warn' */
  const [changePasswordData, setChangePasswordData] = useState(null)

  const handleDisplayChange = (display, data) => {
    if (display === FORM_NAME_USER_ID || display === FORM_NAME_LOGIN_FORM) {
      setDisplayForm(FORM_NAME_USER_ID)
    }

    if (display === FORM_NAME_CHALLENGE_CHOICE) {
      setDisplayForm(display)
      if (data) {
        setMfaData(data)
      }
    }

    if (display === FORM_NAME_ONE_TIME_PASSCODE) {
      setDisplayForm(display)
      setOtpData(data)
    }

    if (display === FORM_NAME_CHALLENGE_QUESTION) {
      setDisplayForm(display)
      setChallengeQuestionData(data)
    }

    if (display === MFA_ANSWERED) {
      if (data.response) {
        const apiToken = data.response.headers.get('apitoken')
        setItem('apiToken', apiToken)
      }
      setDisplayForm(FORM_NAME_CHANGE_PASSWORD)
    }

    if (display === CHANGE_PASSWORD_SUCCESS) {
      window.location.href =
        getRelativeBasePath() + '/login?forgotPassword=true'
    }
  }

  return (
    <div className="u-sizeConstrained">
      {displayForm === FORM_NAME_USER_ID && (
        <UserIdForm
          handleDisplayChange={handleDisplayChange}
          userIdHook={userIdHook}
        />
      )}
      {displayForm === FORM_NAME_CHALLENGE_CHOICE && (
        <ChallengeChoice
          handleDisplayChange={handleDisplayChange}
          mfaResponseData={mfaData}
          showNewUser={false}
          showForgotPasswordLink={false}
        />
      )}
      {displayForm === FORM_NAME_CHALLENGE_QUESTION && (
        <ChallengeQuestion
          handleDisplayChange={handleDisplayChange}
          mode="fyp"
          challengeQuestionData={challengeQuestionData}
          showNewUser={false}
        />
      )}
      {displayForm === FORM_NAME_ONE_TIME_PASSCODE && (
        <OneTimePasscode
          handleDisplayChange={handleDisplayChange}
          mode="fyp"
          otpDta={otpDta}
          loginInputHook={userIdHook}
          showNewUser={false}
        />
      )}
      {displayForm === FORM_NAME_CHANGE_PASSWORD && (
        <ChangePassword
          handleDisplayChange={handleDisplayChange}
          changePasswordData={changePasswordData}
          passwordMode={PASSWORD_MODE.FORGOT_PASSWORD_CHANGE}
          loginInputHook={userIdHook}
          showNewUser={false}
          showForgotPasswordLink={false}
        />
      )}
    </div>
  )
}

ForgotPassword.propTypes = {}

export default ForgotPassword
